module.exports = __webpack_public_path__ + "static/hpba-piramida-new-a-b2b06bd74dd3fea0919293fa9c55e489.svg";